const url = window.location.href;
export function shareUrl() {
    var _a;
    const linkCopied = document.createElement("input");
    linkCopied.setAttribute("value", url);
    document.body.appendChild(linkCopied);
    navigator.clipboard.writeText(linkCopied.value);
    document.body.removeChild(linkCopied);
    (_a = document.getElementById("successAlertCopy")) === null || _a === void 0 ? void 0 : _a.classList.add('show');
    setTimeout(() => {
        var _a;
        (_a = document.getElementById("successAlertCopy")) === null || _a === void 0 ? void 0 : _a.classList.remove('show');
    }, 5000);
}
export function shareEmail(id) {
    var _a;
    const contentTitle = (_a = document.getElementById(id + 'Title')) === null || _a === void 0 ? void 0 : _a.innerHTML;
    const subject = id == 'article' ? "Artículo Estrenar Vivienda" : `Estrenar Vivienda - Proyecto ${contentTitle}`;
    const body = id == 'article' ? `${contentTitle}%0A%0ALee el artículo completo en:%0A%0A${url}` : `Conoce más sobre este proyecto en: ${url}`;
    const shareEmail = document.getElementsByClassName("js-share-email")[0];
    shareEmail.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${body}`;
}
export function shareWhatsapp(id) {
    var _a;
    const contentTitle = (_a = document.getElementById(id + 'Title')) === null || _a === void 0 ? void 0 : _a.innerHTML;
    const message = id == 'article' ? contentTitle + '. Lee el artículo completo en ' + url : 'Conoce más sobre el proyecto ' + contentTitle + ' en ' + url;
    window.open("https://api.whatsapp.com/send?text=" + encodeURIComponent(message));
}
export function shareFacebook() {
    window.open('http://www.facebook.com/sharer.php?u=' + url, 'ventanacompartir', 'toolbar=0, status=0, width=650, height=450');
}
